import { useState, useEffect } from 'react';

const useMicrophoneAccess = (): { hasMicrophoneAccess: boolean; error: Error | null } => {
  const [hasMicrophoneAccess, setHasMicrophoneAccess] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const checkMicrophoneAccess = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        stream.getTracks().forEach((track) => track.stop()); // Stop all tracks to release the microphone
        setHasMicrophoneAccess(true);
        setError(null);
      } catch (err) {
        console.error('Microphone access denied or not available:', err);
        setError(err as Error);
        setHasMicrophoneAccess(false);
      } finally {
        // Handle errors gracefully, regardless of permission status
        const permissionStatus = await navigator.permissions.query({
          name: 'microphone' as PermissionName,
        });
        handlePermissionChange(permissionStatus);
      }
    };

    const handlePermissionChange = (status: PermissionStatus) => {
      if (status.state === 'granted') {
        setHasMicrophoneAccess(true);
        setError(null);
      } else {
        setHasMicrophoneAccess(false);
        setError(new Error('Microphone access denied or not available'));
      }
    };

    const initPermissionListener = async () => {
      try {
        const permissionStatus = await navigator.permissions.query({
          name: 'microphone' as PermissionName,
        });
        handlePermissionChange(permissionStatus);
        permissionStatus.onchange = () => handlePermissionChange(permissionStatus);
      } catch (err) {
        console.error('Permission API error:', err);
        setError(err as Error);
      }
    };

    void checkMicrophoneAccess();
    void initPermissionListener();
  }, []);

  return { hasMicrophoneAccess, error };
};

export default useMicrophoneAccess;
